const hasPermission = function (el, binding) {
    const {value} = binding
    const permissions = localStorage.getItem('userAuth') ? JSON.parse(localStorage.getItem('userAuth')).value : false
    if (permissions && value) {
        const hasDisplay = permissions[value]
        if (!hasDisplay) {
            el.parentNode && el.parentNode.removeChild(el)
        }
    }
}

/**
 * RegisterDirectives
 * 注册指令
 */
export class RegisterDirectives {
    /**
     * @param Vue
     */
    constructor(Vue) {
        Vue.directive('permission', {
            inserted: function (el, binding) {
                hasPermission(el, binding)
            },
            update: function (el, binding) {
                hasPermission(el, binding)
            },
        })
    }
}
